import { useEffect } from "react";
import { Helmet } from "react-helmet";

import '../pages/Etp.css'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ETPPAGE from '../images/ETPPAGE.png'
import RADSTP1 from '../images/RADSTP1.jpg'
import RADSTP2 from '../images/RADSTP2.jpg'
import EtpBan from '../components/EtpBan'
import { FaIndustry, FaRecycle, FaShieldAlt } from "react-icons/fa";
import { FaFlask, FaUtensils, FaTruck } from "react-icons/fa";
import { FaCheckCircle, FaWater, FaLeaf } from "react-icons/fa";
import { FaHome, FaTree } from "react-icons/fa";


import {
  FaBalanceScale,
  FaClipboardCheck,

  FaGavel
} from "react-icons/fa";




import {


  FaBolt,
  FaTools,

  FaUserCog,
  FaBuilding
} from "react-icons/fa";
export default function Etp() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <>
      <Helmet>
        <title>Effluent Treatment Plant (ETP) in Madurai | Industrial Wastewater Treatment</title>
        <meta name="description" content="Leading provider of Effluent Treatment Plant (ETP) in Madurai. We design and install ETPs for textile, pharma, chemical, and food industries to meet PCB norms." />
        <meta name="keywords" content="ETP Plant Madurai, Effluent Treatment Plant Tamil Nadu, Industrial Wastewater Treatment, ZLD System Madurai, PCB Compliant ETP, wastewater recycling Madurai" />
        <link rel="canonical" href="https://radenvironex.com/Etp" />
      </Helmet>
      <Navbar />

      <EtpBan />



      {/* ETP INTRO SECTION */}
      <section id="etp-intro-section">
        <div className="etp-intro-wrapper" data-aos="slide-up">

          <div className="etp-icon">
            <FaIndustry />
          </div>

          <h2>Effluent Treatment Plant (ETP)</h2>

          <p className="etp-desc">
            An <strong>Effluent Treatment Plant (ETP)</strong> is used to treat
            industrial wastewater before it is reused or safely discharged.
            ETPs remove toxic chemicals, oils, heavy metals, and pollutants,
            ensuring compliance with Pollution Control Board (PCB) norms.
          </p>

          <div className="etp-points">
            <div data-aos="fade-up">
              <FaShieldAlt />
              <span>
                Ensures compliance with <strong>PCB discharge standards</strong>
              </span>
            </div>

            <div data-aos="fade-up" data-aos-delay="100">
              <FaRecycle />
              <span>
                Enables <strong>safe reuse or discharge</strong> of treated effluent
              </span>
            </div>
          </div>

          {/* <p className="etp-brand">
            At <strong>RAD EnviroNex</strong>, we design and execute
            <strong> customized ETP solutions</strong> based on industry type,
            effluent characteristics, and discharge standards.
          </p> */}

        </div>
      </section>





      {/* ETP – TYPES OF SYSTEMS */}
      <section id="etp-types-section">
        <div className="etp-types-wrapper" data-aos="fade-up">

          <h3 style={{ color: '#0bbcd6' }}>Types of ETP Systems</h3>

          <div className="etp-types-grid">
            <div data-aos="slide-up">
              <FaRecycle />
              <span>Chemical ETP</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaRecycle />
              <span>Biological ETP</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaRecycle />
              <span>Physico-Chemical ETP</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaWater />
              <span>Zero Liquid Discharge (ZLD) System</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaIndustry />
              <span>Compact / Package ETP</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="500">
              <FaIndustry />
              <span>ETP with RO & Evaporator</span>
            </div>
          </div>

        </div>
      </section>




      {/* ETP – BEST SUITABLE FOR */}
      <section id="etp-suitable-section">
        <div className="etp-suitable-wrapper" data-aos="fade-up">

          <h3 style={{ color: '#0bbcd6' }}>Best Suitable For</h3>

          <div className="etp-suitable-grid">
            <div data-aos="slide-up">
              <FaIndustry />
              <span>Textile & Dyeing Industries</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaFlask />
              <span>Pharmaceutical & Chemical Industries</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaUtensils />
              <span>Food & Beverage Processing Units</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaUtensils />
              <span>Dairy & Brewery Plants</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaIndustry />
              <span>Tanneries & Leather Industries</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="500">
              <FaIndustry />
              <span>Electroplating & Metal Finishing Units</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="600">
              <FaTruck />
              <span>Automobile & Engineering Industries</span>
            </div>
          </div>

        </div>
      </section>


      {/* ETP – REUSE OF TREATED WATER */}
      <section id="etp-reuse-section">
        <div className="etp-reuse-wrapper" data-aos="fade-up">

          <h3 style={{ color: '#0bbcd6' }}>Reuse of Treated Water</h3>

          <div className="etp-reuse-grid">

            {/* Residential & Commercial */}
            <div className="etp-reuse-card" data-aos="slide-up">
              <FaHome />
              <h4>Residential & Commercial</h4>
              <ul>
                <li>Toilet flushing</li>
                <li>Gardening & landscaping</li>
                <li>Floor and driveway washing</li>
                <li>Vehicle washing</li>
              </ul>
            </div>

            {/* Industrial */}
            <div className="etp-reuse-card" data-aos="slide-up" data-aos-delay="150">
              <FaIndustry />
              <h4>Industrial</h4>
              <ul>
                <li>Cooling towers</li>
                <li>Boiler feed (with tertiary treatment)</li>
                <li>Process water (as per quality requirement)</li>
                <li>Dust suppression</li>
              </ul>
            </div>

            {/* Public & Infrastructure */}
            <div className="etp-reuse-card" data-aos="slide-up" data-aos-delay="300">
              <FaTree />
              <h4>Public & Infrastructure</h4>
              <ul>
                <li>Parks and green belts</li>
                <li>Road cleaning</li>
                <li>Construction curing water</li>
              </ul>
            </div>

          </div>
        </div>
      </section>











      {/* ETP PROCESS IMAGE SECTION */}
      {/* <section id="etp-process-section">
  <div
    className="etp-process-wrapper"
    data-aos="slide-up"
  >
    <h2>Process of Effluent Treatment Plant (ETP)</h2>

    <div className="etp-process-image">
      <img src={ETPPAGE} alt="ETP Process Flow Diagram" />
    </div>
  </div>
</section> */}





      {/* WHY CHOOSE RAD – ETP */}
      {/* <section id="etp-why-rad-section">
  <div className="etp-why-wrapper" data-aos="fade-up">

    <h2>Why Choose RAD EnviroNex for ETP?</h2>

    <div className="etp-why-grid">

      <div data-aos="slide-up">
        <FaIndustry />
        <div>
          <h4>Industry-Specific ETP Design</h4>
          <p>
            Customized Effluent Treatment Plants designed based on your
            industry type, effluent characteristics, and discharge norms —
            not one-size-fits-all solutions.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaLeaf />
        <div>
          <h4>PCB-Compliant & Future-Ready</h4>
          <p>
            Strict compliance with CPCB & TNPCB regulations, ensuring smooth
            approvals, safe discharge, and long-term operational reliability.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="200">
        <FaBolt />
        <div>
          <h4>Advanced & Energy-Efficient Technology</h4>
          <p>
            Optimized chemical dosing, biological treatment, and advanced
            filtration systems to achieve high efficiency with reduced
            power and operating cost.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="300">
        <FaTools />
        <div>
          <h4>End-to-End Execution</h4>
          <p>
            From site study → design → supply → installation → commissioning
            → AMC, RAD EnviroNex handles the complete ETP lifecycle under one roof.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="400">
        <FaRecycle />
        <div>
          <h4>Water Reuse & ZLD Expertise</h4>
          <p>
            Specialized in water recycling, RO-based reuse, and Zero Liquid
            Discharge (ZLD) solutions to minimize freshwater dependency.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="500">
        <FaFlask />
        <div>
          <h4>Accurate Process Engineering</h4>
          <p>
            ETP designs based on detailed effluent analysis (pH, BOD, COD,
            TDS, heavy metals) ensuring stable performance and minimal
            trial-and-error.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="600">
        <FaUserCog />
        <div>
          <h4>Skilled Operation & Support</h4>
          <p>
            Experienced technical team providing operator training,
            process optimization, and fast-response service support.
          </p>
        </div>
      </div>

      <div data-aos="slide-up" data-aos-delay="700">
        <FaBuilding />
        <div>
          <h4>Multi-Industry Experience</h4>
          <p>
            Proven ETP solutions across textile, pharma, chemical, food,
            engineering, and manufacturing industries.
          </p>
        </div>
      </div>

    </div>
  </div>
</section> */}

      {/* GOVERNMENT POLICY & REGULATORY VIEW – ETP */}
      <section id="etp-policy-regulation-section">
        <div className="etp-policy-wrapper" data-aos="fade-up">

          <h2 style={{ color: '#0bbcd6' }}>Government Policy & Regulatory View</h2>


          <div className="etp-policy-card" data-aos="slide-up">
            <FaBalanceScale />
            <div>
              <h4>1. Water (Prevention & Control of Pollution) Act, 1974</h4>
              <ul>
                <li>Industries must treat effluent before discharge</li>
                <li>Discharge without treatment is a punishable offence</li>
                <li>Compliance monitored by CPCB & SPCBs</li>
              </ul>
            </div>
          </div>


          <div className="etp-policy-card" data-aos="slide-up" data-aos-delay="100">
            <FaClipboardCheck />
            <div>
              <h4>2. Pollution Control Board (PCB) Requirements</h4>
              <p>Industries must:</p>
              <ul>
                <li>Install a suitable ETP based on effluent characteristics</li>
                <li>Meet prescribed effluent discharge standards</li>
                <li>
                  Obtain statutory approvals:
                  <ul>
                    <li>Consent to Establish (CTE)</li>
                    <li>Consent to Operate (CTO)</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>


          <div className="etp-policy-card" data-aos="slide-up" data-aos-delay="200">
            <FaRecycle />
            <div>
              <h4>3. Zero Liquid Discharge (ZLD) Policy</h4>
              <p>In highly polluting sectors and sensitive zones:</p>
              <ul>
                <li>Government enforces Zero Liquid Discharge (ZLD)</li>
                <li>No wastewater is allowed outside the premises</li>
                <li>Entire treated water must be reused</li>
                <li>Solid waste disposed as per hazardous waste rules</li>
              </ul>
            </div>
          </div>


          <div className="etp-policy-card" data-aos="slide-up" data-aos-delay="300">
            <FaGavel />
            <div>
              <h4>4. Environmental Protection Act, 1986</h4>
              <p>Empowers government to:</p>
              <ul>
                <li>Shut down non-compliant industries</li>
                <li>Impose financial penalties</li>
                <li>Enforce advanced treatment systems</li>
              </ul>
            </div>
          </div>

        </div>
      </section>




      {/* ETP PROCESS IMAGE SECTION */}
      {/* <section id="etp-process-section">
  <div
    className="etp-process-wrapper"
    data-aos="slide-up"
  >
    <h2>Process of Effluent Treatment Plant (ETP)</h2>

    <div className="etp-process-image">
      <img src={RADSTP1} alt="ETP Process Flow Diagram" />
    </div>
  </div>
</section> */}




      {/* ETP PROCESS IMAGE SECTION */}
      {/* <section id="etp-process-section">
  <div
    className="etp-process-wrapper"
    data-aos="slide-up"
  >
    <h2>Process of Effluent Treatment Plant (ETP)</h2>

    <div className="etp-process-image">
      <img src={RADSTP2} alt="ETP Process Flow Diagram" />
    </div>
  </div>
</section> */}






      {/* ETP – BENEFITS */}
      {/* <section id="etp-benefits-section">
        <div className="etp-benefits-wrapper" data-aos="fade-up">

          <h3>Benefits of Effluent Treatment Plant</h3>

          <div className="etp-benefits-grid">
            <div data-aos="slide-up">
              <FaCheckCircle />
              <span>Meets PCB & environmental norms</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaLeaf />
              <span>Prevents soil & water pollution</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaRecycle />
              <span>Enables water recycling & reuse</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaWater />
              <span>Reduces freshwater consumption</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaLeaf />
              <span>Improves industry sustainability rating</span>
            </div>
          </div>

        </div>
      </section> */}



      <Footer />




    </>
  )
}
